import create from 'zustand';
import { ReportDxData, ReportMxData } from '../types';

interface MonthlyReportState {
  reportMxData: ReportMxData | null;
  reportDxData: ReportDxData | null;
  selectedMonth: Date; // 선택한 월

  setSelectedMonth: (selectedMonth: Date) => void; // 선택한 월을 설정
  setReportMxData: (reportMxData: ReportMxData | ((prev: ReportMxData | null) => ReportMxData)) => void;
  setReportDxData: (reportDxData: ReportDxData) => void;
}

/**
 * 월간 보고서 스토어
 */
export const useMonthlyReportStore = create<MonthlyReportState>((set) => ({
  reportMxData: null,
  reportDxData: null,
  selectedMonth: new Date(),

  /**
   * 월 데이터를 설정한다.
   */
  setReportMxData: (reportMxData) => {
    if (typeof reportMxData === 'function') {
      set((state) => ({ reportMxData: reportMxData(state.reportMxData) })); // 함수형 지원을 위해 추가
    } else {
      set({ reportMxData });
    }
  },
  resetReportMxData: () => set({ reportMxData: null }),
  setReportDxData: (reportDxData: ReportDxData) => set({ reportDxData }),
  setSelectedMonth: (selectedMonth: Date) => set({ selectedMonth }),
}));

/**
 * 보고서 제출 여부 확인
 * : 제출된 보고서는 수정 불가능하다.
 */
export const useIsReadOnly = () => {
  return useMonthlyReportStore((state) => state.reportMxData?.is_submitted === 'Y');
};
